import { render, staticRenderFns } from "./NewClientContact.vue?vue&type=template&id=54284278&"
import script from "./NewClientContact.vue?vue&type=script&lang=js&"
export * from "./NewClientContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54284278')) {
      api.createRecord('54284278', component.options)
    } else {
      api.reload('54284278', component.options)
    }
    module.hot.accept("./NewClientContact.vue?vue&type=template&id=54284278&", function () {
      api.rerender('54284278', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Components/NewClientContact.vue"
export default component.exports